var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"main-wrap"},[_c('div',{staticClass:"settings-header"},[_vm._v("\n          ORGANIZATION / Chart of Accounts (CoA)\n        ")]),_c('chart-of-accounts',{attrs:{"state":"view"}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }